export const UPDATE_FREE_GIFT_START = 'UPDATE_FREE_GIFT_START';

export const UPDATE_FREE_GIFT_SUCCESS = 'UPDATE_FREE_GIFT_SUCCESS';

export const UPDATE_FREE_GIFT_FAILED = 'UPDATE_FREE_GIFT_FAILED';
